import memoize from 'lodash/memoize';

/**
 * Memoized to prevent computing the native scrollbar size unnecessarily
 * when it is READ from multiple synced scroll views.
 *
 */
export const getNativeScrollbarSizeMemoed = memoize(() => {
	const outerEl = document.createElement('div');
	const innerEl = document.createElement('div');
	Object.assign(outerEl.style, {
		overflowX: 'scroll',
		width: '50px',
	});
	Object.assign(innerEl.style, {
		width: '100px',
	});
	outerEl.appendChild(innerEl);
	document.body?.appendChild(outerEl);
	const nativeScrollBarSize = outerEl.offsetHeight - outerEl.clientHeight;
	document.body?.removeChild(outerEl);

	return nativeScrollBarSize;
});
